import { Box } from "@material-ui/core";
import useText from "constants/text";
import { AnimatedDiv, ContainerRecapHeader, VehicleIcon } from "../../MainStyles";
import { requestContainerBgColor, useDetailsStyles, VehicleIconType } from "../../RightSideDetails";
import HeaderRequestDetails from "../HeaderRequestDetails";

interface VehicleDetailsProps {
  requestToDisplay?: any;
}

const VehicleDetails = ({ requestToDisplay }: VehicleDetailsProps) => {
  const { text } = useText();
  const styles = useDetailsStyles();

  return (
    <>
      <Box className={styles.details}>
        {text.all.vehicle_type} <hr className={styles.hr} />
      </Box>
      <AnimatedDiv background-color={requestContainerBgColor[requestToDisplay?.type || "NT"]}>
        <ContainerRecapHeader>
          <VehicleIcon>{VehicleIconType[requestToDisplay?.vehicles[0]?.vehicleType]}</VehicleIcon>
          <HeaderRequestDetails type={requestToDisplay?.type} request={requestToDisplay} />
        </ContainerRecapHeader>
      </AnimatedDiv>
    </>
  );
};

export default VehicleDetails;
